/* ============================================================
   Pulse Hero Slider — pulse-hero-slider.js
   Vanilla JS, no external dependencies
   Features: fade transition, autoplay, infinite loop,
             arrows, dots, touch/swipe, keyboard, hover-pause,
             staggered content animation
   ============================================================ */

(function () {
  'use strict';

  function PulseHeroSlider(sectionEl) {
    var self          = this;
    self.section      = sectionEl;
    self.slides       = Array.prototype.slice.call(sectionEl.querySelectorAll('.phs__slide'));
    self.total        = self.slides.length;
    self.current      = 0;
    self.timer        = null;
    self.isAnimating  = false;

    if (self.total < 1) return;

    self.autoplay   = sectionEl.dataset.autoplay === 'true';
    self.speed      = parseInt(sectionEl.dataset.speed, 10) || 5000;
    self.showArrows = sectionEl.dataset.arrows === 'true';
    self.showDots   = sectionEl.dataset.dots === 'true';

    self.prevBtn    = sectionEl.querySelector('.phs__nav--prev');
    self.nextBtn    = sectionEl.querySelector('.phs__nav--next');
    self.dotsEl     = sectionEl.querySelector('.phs__pagination');

    self._buildDots();
    self._bindEvents();
    self._goTo(0, true);

    if (self.autoplay && self.total > 1) {
      self._startAutoplay();
    }
  }

  /* ── Build pagination dots ────────────────────────────────── */
  PulseHeroSlider.prototype._buildDots = function () {
    var self = this;
    if (!self.dotsEl || self.total <= 1) return;

    self.dotsEl.innerHTML = '';
    for (var i = 0; i < self.total; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'phs__dot' + (i === 0 ? ' phs__dot--active' : '');
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.dataset.index = i;
      self.dotsEl.appendChild(btn);
    }
  };

  /* ── Update dots ──────────────────────────────────────────── */
  PulseHeroSlider.prototype._updateDots = function () {
    var self = this;
    if (!self.dotsEl) return;
    var dots = self.dotsEl.querySelectorAll('.phs__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('phs__dot--active', i === self.current);
    }
  };

  /* ── Go to slide ──────────────────────────────────────────── */
  PulseHeroSlider.prototype._goTo = function (index, instant) {
    var self = this;
    if (self.isAnimating && !instant) return;

    index = ((index % self.total) + self.total) % self.total;

    var prev = self.current;
    self.current = index;

    if (self.slides[prev] && prev !== index) {
      self.slides[prev].classList.remove('phs__slide--active');
      self.slides[prev].setAttribute('aria-hidden', 'true');
    }

    var incoming = self.slides[index];
    incoming.setAttribute('aria-hidden', 'false');

    if (instant) {
      incoming.classList.add('phs__slide--active');
      self._triggerContentAnimation(incoming);
    } else {
      self.isAnimating = true;
      incoming.classList.add('phs__slide--active');
      self._triggerContentAnimation(incoming);
      setTimeout(function () {
        self.isAnimating = false;
      }, 900);
    }

    self._updateDots();
  };

  /* ── Next / Prev ──────────────────────────────────────────── */
  PulseHeroSlider.prototype.next = function () {
    this._goTo(this.current + 1);
    this._restartAutoplay();
  };

  PulseHeroSlider.prototype.prev = function () {
    this._goTo(this.current - 1);
    this._restartAutoplay();
  };

  /* ── Content stagger animation ──────────────────────────────── */
  PulseHeroSlider.prototype._triggerContentAnimation = function (slide) {
    var targets = slide.querySelectorAll(
      '.phs__badge, .phs__heading, .phs__description, .phs__buttons'
    );

    for (var i = 0; i < targets.length; i++) {
      targets[i].style.transition = 'none';
      targets[i].style.opacity    = '0';
      targets[i].style.transform  = 'translateY(22px)';
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        for (var i = 0; i < targets.length; i++) {
          targets[i].style.transition = '';
          targets[i].style.opacity    = '';
          targets[i].style.transform  = '';
        }
      });
    });
  };

  /* ── Autoplay ───────────────────────────────────────────────── */
  PulseHeroSlider.prototype._startAutoplay = function () {
    var self = this;
    if (self.total <= 1) return;
    self.timer = setInterval(function () {
      self._goTo(self.current + 1);
    }, self.speed);
  };

  PulseHeroSlider.prototype._stopAutoplay = function () {
    clearInterval(this.timer);
    this.timer = null;
  };

  PulseHeroSlider.prototype._restartAutoplay = function () {
    if (!this.autoplay) return;
    this._stopAutoplay();
    this._startAutoplay();
  };

  /* ── Event binding ──────────────────────────────────────────── */
  PulseHeroSlider.prototype._bindEvents = function () {
    var self = this;

    if (self.prevBtn) {
      self.prevBtn.addEventListener('click', function () { self.prev(); });
    }
    if (self.nextBtn) {
      self.nextBtn.addEventListener('click', function () { self.next(); });
    }

    if (self.dotsEl) {
      self.dotsEl.addEventListener('click', function (e) {
        var dot = e.target.closest('.phs__dot');
        if (!dot) return;
        var idx = parseInt(dot.dataset.index, 10);
        self._goTo(idx);
        self._restartAutoplay();
      });
    }

    if (self.autoplay) {
      self.section.addEventListener('mouseenter', function () {
        self._stopAutoplay();
      });
      self.section.addEventListener('mouseleave', function () {
        self._startAutoplay();
      });
    }

    self.section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { self.prev(); }
      if (e.key === 'ArrowRight') { self.next(); }
    });

    var touchStartX = 0;
    var touchStartY = 0;

    self.section.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    self.section.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        if (dx < 0) { self.next(); } else { self.prev(); }
      }
    }, { passive: true });
  };

  /* ── Destroy (Theme Editor cleanup) ─────────────────────────────── */
  PulseHeroSlider.prototype.destroy = function () {
    this._stopAutoplay();
  };

  /* ── Init all sliders on the page ─────────────────────────────── */
  function initAll() {
    var sections = document.querySelectorAll('.phs[data-section-type="pulse-hero-slider"]');
    for (var i = 0; i < sections.length; i++) {
      if (!sections[i]._phsInstance) {
        sections[i]._phsInstance = new PulseHeroSlider(sections[i]);
      }
    }
  }

  /* ── Shopify Theme Editor events ───────────────────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.phs[data-section-type="pulse-hero-slider"]');
    if (section) {
      section._phsInstance = new PulseHeroSlider(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.phs[data-section-type="pulse-hero-slider"]');
    if (section && section._phsInstance) {
      section._phsInstance.destroy();
    }
  });

  /* ── Boot ───────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
